/**
 * Sprint 006 (A3) — Shared filter pill / toggle chip.
 *
 * Canonical chip anatomy lifted from the /invoices Quartale-Toggle
 * (the ratified positive reference): h-8, rounded-lg, white/x states.
 * Used for status filters, quick toggles, and view chips so every list
 * page speaks one pill language.
 */
import { type ButtonHTMLAttributes, type ReactNode } from 'react';

interface FilterPillProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  icon?: ReactNode;
  /** Optional trailing count, rendered de-emphasized. */
  count?: number;
  children: ReactNode;
}

export function FilterPill({
  active = false,
  icon,
  count,
  children,
  className = '',
  type = 'button',
  ...rest
}: FilterPillProps) {
  return (
    <button
      type={type}
      aria-pressed={active}
      className={`h-8 px-2.5 inline-flex items-center gap-1.5 border rounded-lg text-sm transition-colors ${
        active
          ? 'bg-white/10 text-white border-white/20'
          : 'bg-white/5 text-white/70 border-white/10 hover:text-white hover:bg-white/10'
      } ${className}`}
      {...rest}
    >
      {icon}
      <span>{children}</span>
      {count !== undefined && (
        <span className={active ? 'text-white/60' : 'text-white/40'}>{count}</span>
      )}
    </button>
  );
}

export default FilterPill;
